import { memoizedGenerateCumulativeDailyNetDeposits } from "../hooks/SummaryScreen/useGetNetDeposits";
import { memoizedGenerateCumulativeDailyNetDeposits as memoizedGenerateCumulativeDailyNetDepositsV4 } from "../hooks/SummaryScreen/useGetNetDepositsV4";
import { memoizedCreateDateRangesBetween, memoizedGetGroupFromResponse, } from "../hooks/useGetAccountGroupForTimeFrame";
import { memoizedCreateDateRangesBetween as memoizedCreateDateRangesBetweenV4, memoizedGetGroupFromResponse as memoizedGetGroupFromResponseV4, } from "../hooks/useGetAccountGroupForTimeFrameV4";
import { memoizedCalculateDateRangeFromTimeFrame, memoizedGenDateRangeObject, } from "../hooks/useGetDatesForTimeFrame";
import { memoizedCalculateDateRangeFromTimeFrame as memoizedCalculateDateRangeFromTimeFrameV4, memoizedGenDateRangeObject as memoizedGenDateRangeObjectV4, } from "../hooks/useGetDatesForTimeFrameV4";
import { memoizedDayMapper, memoizedEachDayOfInterval, } from "../hooks/usePerformanceGroupSummary";
import { memoizedDayMapper as memoizedDayMapperV4, memoizedEachDayOfInterval as memoizedEachDayOfIntervalV4, } from "../hooks/usePerformanceGroupSummaryV4";
export default function clearMemoizedCaches() {
    memoizedGenerateCumulativeDailyNetDeposits.cache.clear?.();
    memoizedGenerateCumulativeDailyNetDepositsV4.cache.clear?.();
    memoizedCreateDateRangesBetween.cache.clear?.();
    memoizedCreateDateRangesBetweenV4.cache.clear?.();
    memoizedGetGroupFromResponse.cache.clear?.();
    memoizedGetGroupFromResponseV4.cache.clear?.();
    memoizedCalculateDateRangeFromTimeFrame.cache.clear?.();
    memoizedCalculateDateRangeFromTimeFrameV4.cache.clear?.();
    memoizedGenDateRangeObject.cache.clear?.();
    memoizedGenDateRangeObjectV4.cache.clear?.();
    memoizedEachDayOfInterval.cache.clear?.();
    memoizedEachDayOfIntervalV4.cache.clear?.();
    memoizedDayMapper.cache.clear?.();
    memoizedDayMapperV4.cache.clear?.();
}
//# sourceMappingURL=clearMemoizedCaches.js.map